import { getSelectedTableView } from "owa-mail-list-store";
import { lazyRestoreMailListRowsAction } from "owa-mail-triage-action";
import { resetFocus } from "owa-mail-focus-manager";
import type { ActionSource } from "owa-analytics-types";
import getEffectiveRowKeys from "owa-mail-list-store/lib/utils/getEffectiveRowKeys";

export default function onRestore(actionSource: ActionSource): void {
    const tableView = getSelectedTableView(true /* shouldGetEffectiveTableView */);
    if (!tableView) {
        return;
    }
    const rowKeys = getEffectiveRowKeys(tableView);
    
    lazyRestoreMailListRowsAction.importAndExecute(rowKeys, tableView.id, actionSource);
    resetFocus("restoreCommand");
}
